import { useCallback } from 'react'

import { apiUrl, toQuery, useApiRequest } from '../useApiRequest'

import { ClubAvailability } from '../../types/booking/booking'

/**
 * Bookable start times for one club and day, for every session length the club offers (computed by the server, no
 * pre-generated slots). Days beyond the caller's booking window have no starts, except for managers. While rescheduling,
 * the booking being moved does not block its own interval.
 */
export function useAvailability() {
  const { run, loading, error, resetState } = useApiRequest()

  const availability = useCallback(
    (clubId: number, date: string, rescheduledBookingId?: number) =>
      run(({ fetcher }) =>
        fetcher<ClubAvailability>(
          apiUrl(`/clubs/${clubId}/availability${toQuery({ date, rescheduledBookingId })}`)
        )
      ),
    [run]
  )

  return { availability, loading, error, resetState }
}
